import AppButton from "../../../reusableComponent/button/button";
import styles from "./errorPage.module.scss";

const ErrorPage = ({ onRefresh, message }: { onRefresh: any; message: string }) => {
  return (
    <div className={styles.main}>
      <h2 className={styles.title}>{message?.replace(/\\n/g, "\n")?.trim()}</h2>
      <AppButton onClick={onRefresh}>Refresh</AppButton>
      {/* <button className={styles.btn} onClick={onRefresh}>
        Refresh
      </button> */}
    </div>
  );
};
export default ErrorPage;
